// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";
import * as Subsonic__Response from "./response.jsx";
import * as Subsonic__SimilarArtist from "./similarArtist.jsx";

function withoutSimilarArtist_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.biography;
  const v$1 = x.lastFmUrl;
  const v$2 = x.musicBrainzId;
  return {
    biography: v !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v) : undefined,
    lastFmUrl: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$1) : undefined,
    musicBrainzId: v$2 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$2) : undefined
  };
}

function withoutSimilarArtist_to_json(x) {
  return {
    biography: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.biography),
    lastFmUrl: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.lastFmUrl),
    musicBrainzId: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.musicBrainzId)
  };
}

function info_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.biography;
  const v$1 = x.lastFmUrl;
  const v$2 = x.musicBrainzId;
  const v$3 = x.similarArtist;
  return {
    biography: v !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v) : undefined,
    lastFmUrl: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$1) : undefined,
    musicBrainzId: v$2 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json(Ppx_deriving_json_runtime.Primitives.string_of_json, v$2) : undefined,
    similarArtist: v$3 !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json((function (param) {
        return Ppx_deriving_json_runtime.Primitives.array_of_json(Subsonic__SimilarArtist.of_json, param);
      }), v$3) : undefined
  };
}

function info_to_json(x) {
  return {
    biography: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.biography),
    lastFmUrl: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.lastFmUrl),
    musicBrainzId: Ppx_deriving_json_runtime.Primitives.option_to_json((function (prim) {
      return prim;
    }), x.musicBrainzId),
    similarArtist: Ppx_deriving_json_runtime.Primitives.option_to_json((function (param) {
      return Ppx_deriving_json_runtime.Primitives.array_to_json(Subsonic__SimilarArtist.to_json, param);
    }), x.similarArtist)
  };
}

function body_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.status;
  let tmp;
  if (v !== undefined) {
    const tag = Ppx_deriving_json_runtime.Primitives.string_of_json(v);
    tmp = tag === "ok" ? "ok" : Ppx_deriving_json_runtime.of_json_error("invalid JSON");
  } else {
    tmp = Ppx_deriving_json_runtime.of_json_error("missing field \"status\"");
  }
  const v$1 = x.artistInfo2;
  return {
    status: tmp,
    artistInfo2: v$1 !== undefined ? info_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"artistInfo2\"")
  };
}

function body_to_json(x) {
  return {
    status: "ok",
    artistInfo2: info_to_json(x.artistInfo2)
  };
}

function of_json(x) {
  return Subsonic__Response.of_json(body_of_json, x);
}

function to_json(x) {
  return Subsonic__Response.to_json(body_to_json, x);
}

export {
  withoutSimilarArtist_of_json,
  withoutSimilarArtist_to_json,
  info_of_json,
  info_to_json,
  body_of_json,
  body_to_json,
  of_json,
  to_json,
}
/* No side effect */
